<template>
    <div class="page-wrap pt-3">
        <div class="session-form-hold">
            <div>
                <v-progress-linear
                    :active="loading"
                    :indeterminate="loading"
                    absolute
                    top
                    color="white"
                />
                <v-card-text class="text-center my-0 py-0">
                    <div style="display: flex; flex-direction: column; align-items: center;" class="mt-6">
                        <span
                            style="color: white; background-color: #0646ed; padding: 7px 15px"
                        >  {{ $t('users.login.help.selectMainLang') }}
                            <br /><language-selector color="white" />
                        </span>

                        <v-img
                            class="mb-2 mt-16"
                            src="@/assets/img/logo-white.png"
                            alt=""
                            max-width="220px"
                            contain
                        />
                    </div>

                    <div class="mb-3">
                        <span
                            color="white"
                            style="font-size: x-large; color: white"
                            v-html="$t('users.login.title')"
                        />
                    </div>

                    <span class="red--text mb-2">
                        {{ serverError }}
                    </span>

                    <div class="sign-in">
                        <span
                            style="color: white"
                            v-html="$t('auth.microsoft.title')"
                        />

                        <v-btn
                            class="mt-2"
                            block
                            color="dark"
                            dark
                            style="z-index: 3;"
                            x-large
                            @click="loginMicrosoft"
                        >
                            <v-img
                                class="mr-2"
                                src="@/assets/img/svg/microsoft_logo.svg"
                                alt="Login with Microsoft"
                                max-width="28px"
                                contain
                            />
                            {{ $t('auth.microsoft.buttonLoging') }}
                        </v-btn>

                        <div class="d-flex justify-center flex-wrap">
                            <instructions/>
                        </div>
                    </div>
                </v-card-text>
            </div>
        </div>

        <v-img
            class="parpadea"
            src="@/assets/img/background_person.png"
            alt=""
            max-height="35vh"
            contain
        />

        <confirm-dialog
            ref="confirm"
        />
    </div>
</template>
<script>

import { mapGetters, mapActions } from 'vuex'
import rules from '@/helpers/rulesValidate'
import axios from '@/plugins/axios'
import LanguageSelector from "@/components/common/LanguageSelector";
import ConfirmDialog from '@/components/common/ConfirmDialog'
import instructions from "@/components/sessions/instructions";


export default {
    name: 'Login',
    metaInfo: {
        // title will be injected into parent titleTemplate
        // title: this.$t('users.login.title')
    },
    components: { LanguageSelector, ConfirmDialog, instructions},
    data() {
        return {
            isValid: true,
            serverCheck: false,
            serverError: '',
            showIcon: false,
            password: 'Password',
            checkbox1: true,
            checkbox2: false,
            email: '',
            ePassword: '',
            loading: false,
            rules: {
                ...rules
            },
            canSignUp: false
        }
    },
    computed: {
        ...mapGetters(['loggedInUser', 'error'])
    },
    created() {
        // this.loadConfig();
    },
    methods: {
        ...mapActions(['login']),

        loginMicrosoft() {
            const tenantITPAzure = 'afd4ba62-50df-4a53-b625-37f81cf80dc6';
            window.location.replace(process.env.VUE_APP_API_SERVER + '/web/' + tenantITPAzure + '/login');
        },
        /* async loadConfig() {
            const configs = await axios
                .get('configs/1');

            let options = configs?.data?.data?.attributes?.options;
            if (options) {
                options = JSON.parse(options);
                this.canSignUp = options?.canRegister ?? false;
            }
        }, */

        async formSubmit() {
            if (!this.$refs.form.validate()) return false;

            const result = await this.login({
                username: this.email.trim(),
                password: this.ePassword
            });

            if (result !== true) {
                const error = result.error;
                if (error === 'change_password') {
                    if (
                        await this.$refs.confirm.open(
                            this.$t('users.login.newPassMSG.title'),
                            this.$t('users.login.newPassMSG.msg'),
                            { noCancel: true }
                        )
                    ) {
                        const token = result.token;
                        //  "/app/sessions/pass-reset/?token="
                        this.$router.push('pass-reset/?token=' + token);
                    }
                } else {
                    this.serverError = this.$t(`errors.${error}`);
                }
            }
        },
        goToDownloadInstruction() {
            window.location.href = "https://itpaerovaluesawards.com/download/";
        }
    },
    watch: {
        // loading (val) {
        //   if (!val) return
        //   setTimeout(() => (this.loading = false), 2000)
        // },
        loggedInUser(val) {
            if (val && val.token && val.token.length > 0) {
                // this.makeToast("success", "Successfully Logged In");
                /* console.log('logged in successfully ') */
                this.loading = true
                setTimeout(() => {
                    /* console.log(val.roles)
                    console.log('val.roles') */
                    if (val.roles?.find(role => role.name === 'Admin')) {
                        this.$router.push('/app/admin')
                    } else {
                        this.$router.push('/')
                    }
                }, 500)
            }
        },
        error(val) {
            if (val != null) {
                // this.makeToast("warning", val.message);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.page-wrap {
  background-color: #242939 !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 40px 1rem;
  height: 100%;
  min-height: 100%;

}

.session-form-hold {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}

.sign-in {
    margin-top: 15vh;
}
</style>
